import React, { useState } from 'react';

const sizes = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-11 w-11 text-sm',
  lg: 'h-20 w-20 text-2xl',
};

function initials(name = '') {
  return name
    .split(' ')
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export default function Avatar({ src, name, size = 'md', className = '' }) {
  const [errored, setErrored] = useState(false);
  const dims = sizes[size];

  if (!src || errored) {
    return (
      <div
        className={`flex shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-accent-500 to-violet-600 font-semibold text-white ${dims} ${className}`}
        aria-hidden="true"
      >
        {initials(name) || '?'}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name ? `${name}'s avatar` : 'User avatar'}
      width={80}
      height={80}
      loading="lazy"
      onError={() => setErrored(true)}
      className={`shrink-0 rounded-full object-cover ring-2 ring-border ${dims} ${className}`}
    />
  );
}
